import React from 'react';
import styled from 'styled-components';
import Toast from 'components/Toast';
import {WithToasts} from './withToasts';


export default class Toasts extends React.Component {

    renderToasts = (toasts) => (
        Object.keys(toasts).map(id => (
            <ToastWrapper key={id}>
                <Toast toastId={id} {...toasts[id]}/>
            </ToastWrapper>
        ))
    );

    render() {
        return (
            <Wrapper>
                <WithToasts render={this.renderToasts}/>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  left: 50%;
  width: 100%;
  max-width: 720px;
  transform: translate(-50%, 0);
  z-index: 2000;
`;

const ToastWrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;
  transition: all 1s;
  animation: 0.5s slideup;
  position: relative;

  @keyframes slideup {
    from {margin-top: -88px; bottom: -88px}
    to {margin-top: 0; bottom: 0}
  }
`;
